define('views/blocks/FakeBannerAppView',['underscore', 'backbone','app',
    'template!blocks/fake-banner-app',
    'moment','js-cookie','modernizr'], function (
    _, Backbone,app,
    fakeBannerAppTemplate,
    moment,Cookies) {


    var cookieKey = 'fake-banner-app-close',
        TARGET,
        FakeBannerAppModel = Backbone.Model.extend({
        default:{
            closed:false
        },
        initialize:function(){
            var closed = Cookies.get(cookieKey);
            if(closed){
                this.set('closed',closed);
            }
        },
        save:function(){
            Cookies.set(cookieKey,new Date(),{expires:getCookieExpires()});
        }
    }), fakeBannerAppModel = new FakeBannerAppModel();

    function getCookieExpires(){
        return parseInt(app.get('_APP_INSTALL_COOKIE_DAY_EXPIRES_','30')) || 30;
    }

    function requireOpenning(){
        TARGET = getTarget();
        var inapp = Modernizr.inapp,
            closed = fakeBannerAppModel.get('closed'),
            // uniquement sur android
            enabled = !!TARGET && !!parseInt(app.c('_FAKE_BANNER_APP_'+TARGET+'_ENABLED_',1));
       if(closed){
           var closedDate = moment(new Date(closed));
           closed = moment.max(closedDate,moment().subtract(getCookieExpires(),'d')).isSame(closedDate);
       }
       return !inapp && enabled && !closed;
    }

    function getTarget(){
        var target = false, ua = navigator.userAgent;
        if(app.isMobile()){
            // only on iOS Chrome, Opera, Firefox
            if(Modernizr.iphone && ua.match(/CriOS|OPiOS|FxiOS/i)){
                target = 'IOS';
            }else if(Modernizr.android) {
                target = 'ANDROID';
            }else{
                target = false;
            }
        }else{
            target = false;
        }
        return target;
    }

    var FakeBannerAppView = Backbone.View.extend({
        events: {
            'click .close':'close',
            'click #fake-banner-app-button':'open'
        },
        initialize: function () {
            var view = this;
            view.subviews = [];
            view.render();
        },
        render:function(){
            var view = this,
                conf_prefix = '_FAKE_BANNER_APP_'+TARGET,
                title = app.c(conf_prefix+'_TITLE_', app.getShopName()),
                cta = app.c(conf_prefix+'_CTA_', '-'),
                app_rating_value = parseFloat(app.c(conf_prefix+'_RATING_VALUE_', '4.5')),
                app_rating_count = parseFloat(app.c(conf_prefix+'_RATING_COUNT_','0'));
            view.$el.html(fakeBannerAppTemplate({
                title:title,
                cta:cta,
                app_rating_value:app_rating_value,
                app_rating_count:app_rating_count,
            }));
            view.delegateEvents();
        },
        close:function(){
            fakeBannerAppModel.save();
            this.remove();
        },
        open:function(){
            //this.close();
            location.href = app.c('_FAKE_BANNER_APP_'+TARGET+'_URL_','');
        }
    });

    FakeBannerAppView.requireOpenning = requireOpenning;

    return FakeBannerAppView;
});
